import type { NotificationItem } from '@/types';

export const notificationsAdapter = (data: NotificationItem[]): NotificationItem[] => {
    return data.map((item) => ({
        ...item,
        loadingItem: false
    }));
};
